import { ChangeDetectorRef, Component, EventEmitter, inject, Input, Output, TemplateRef, ViewChild } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { BsModalRef, BsModalService, ModalModule } from 'ngx-bootstrap/modal';
import { ToastrModule, ToastrService } from 'ngx-toastr';
import { ApiService } from '../../../services/api.service';
import { CommonModule } from '@angular/common';
import { AgGridAngular } from 'ag-grid-angular';
import { GridApi, ClientSideRowModelModule, ValidationModule, PaginationModule, RowSelectionModule, RowDragModule, TooltipModule, RenderApiModule, GridReadyEvent } from 'ag-grid-community';
import { ConfirmDialogComponent } from '../../reusable/confirm-dialog/confirm-dialog.component';
import { BreadcrumbComponent } from '../../reusable/breadcrumb/breadcrumb.component';
import { Store } from '@ngrx/store';
import { Observable, take } from 'rxjs';
import { AppState } from '../../../store';
import { selectCurrentFlow, selectOrganisationId } from '../../../store/organisation/organisation.selectors';
import { CreateUserComponent } from '../../manage-user/create-user/create-user.component';
import { clearBranchId, setBranchId } from '../../../store/branch/branch.actions';
import { clearOrganisationId, setOrganisationId } from '../../../store/organisation/organisation.actions';
import { SingleSelectDropdownComponent } from '../../reusable/single-select-dropdown/single-select-dropdown.component';

@Component({
  selector: 'app-create-branch',
  imports: [ModalModule, CommonModule, FormsModule, ReactiveFormsModule, ToastrModule, AgGridAngular, ConfirmDialogComponent, BreadcrumbComponent,SingleSelectDropdownComponent],
  templateUrl: './create-branch.component.html',
  styleUrl: './create-branch.component.scss',
  providers: [BsModalService]
})
export class CreateBranchComponent {
  branchForm!: FormGroup;
  selectedFile!: File | null;
  branchData: any;
  currentFlow: string|null = null;
  branch: any;
  logoPreview: any;
  logoError: boolean = false;
  organizationsList: any[] = [];
  timezonesList: any[] = [
    { id: 'Asia/Kolkata', name: 'Asia/Kolkata' },
  ];
  parentPage: any;
  breadcrumbItems: Array<{ label: string }> = [];
  @Output() modalClosed = new EventEmitter<void>();
  @ViewChild('cellTemplate', { static: true }) cellTemplate!: TemplateRef<any>;
  @ViewChild(AgGridAngular) agGrid!: AgGridAngular;
  @ViewChild(ConfirmDialogComponent) confirmDialog!: ConfirmDialogComponent;
  @Input() organizationName: string | undefined; 
  selectedRowData: any;
  gridApi!: GridApi;
  rowData: any[] = [];
  private store = inject(Store<AppState>);
  organisationId: any;
  modalRef?: BsModalRef;

  branchTypeList = [
  { id: 'CLINIC', name: 'Clinic' },
  { id: 'HOSPITAL', name: 'Hospital' }
];


 
  columnDefs: any = [
    {
      headerName: 'Branch Name', tooltipField: 'name', field: 'name', tooltipValueGetter: (params: any) => params.value || 'No data', sortable: true, flex: 1
    },
    {
      headerName: 'Email Address', tooltipField: 'contact_email', field: 'contact_email', tooltipValueGetter: (params: any) => params.value || 'No data', sortable: true, flex: 1
    },
    {
      headerName: 'Contact Number', tooltipField: 'contact_number', field: 'contact_number', tooltipValueGetter: (params: any) => params.value || 'No data', sortable: true, flex: 1
    },
    {
      headerName: 'Status', field: 'is_active', tooltipField: 'is_active', valueGetter: (params: any) => params.data.is_active ? 'Disable' : 'Active', sortable: true, flex: 1
    },
    {
      headerName: 'Actions',
      field: 'actions',
      cellRenderer: (params: any) => {
        return this.getHtml(params);
      },
      sortable: false,
      filter: false,
      flex: 1
    }
  ];

  modules = [ClientSideRowModelModule, ValidationModule, PaginationModule, RowSelectionModule, RowDragModule, TooltipModule, RenderApiModule];
  pagination = true;
  paginationPageSize = 1;
  gridOptions = {
    suppressMovableColumns: false,
    rowDragManaged: false,
    animateRows: true,
    enableBrowserTooltips: true,
  };
  localityList: any;
  constructor(
    public branchModalRef: BsModalRef,
    private fb: FormBuilder,
    private apiService: ApiService,
    private cdr: ChangeDetectorRef,
    private toastr: ToastrService,
    private modalService: BsModalService,
  ) { }

  async ngOnInit() {
    this.branchForm = this.fb.group({
      name: [null, [Validators.required, Validators.maxLength(50)]],
      latitude: [null, [Validators.required, this.decimalPrecisionValidator(9, 6)]],
      longitude: [null, [Validators.required, this.decimalPrecisionValidator(9, 6)]],
      contact_number: [null, [Validators.required, Validators.maxLength(50)]],
      contact_email: [null, [Validators.required, Validators.email]],
      address: [null, [Validators.required]],
      pincode: [null, [Validators.maxLength(6)]],
      branch_type: [null, [Validators.required, Validators.maxLength(50)]],
      timezone: ['Asia/Kolkata', [Validators.required, Validators.maxLength(50)]],
      locality_id: [null, Validators.required],
      organisation_id: [null, Validators.required],
      is_email_mrd_allowed: [false],
      branch_google_map_url: [null],
      deleted: [false],
    });
    await Promise.all([
      this.getOrganisation(),
      this.getLocality()
    ]);
    if (this.branchData) {
      this.store.dispatch(setBranchId({ branch_id: this.branchData?.id }));
      this.store.dispatch(setOrganisationId({ organisation_id: this.branchData?.organisation_id }));

    }
    this.store.select(selectOrganisationId).pipe(take(1)).subscribe((organisationId: any) => {
      if(!organisationId)return;
      console.log(organisationId)
      this.organisationId = organisationId;
      this.branchForm.patchValue({ organisation_id: this.organisationId });
      this.store.select(selectCurrentFlow).pipe(take(1)).subscribe((flow) => {
        this.currentFlow = flow;
        console.log(this.currentFlow)
        if(this.currentFlow)this.branchForm.get('organisation_id')?.disable();
        else this.branchForm.get('organisation_id')?.enable();
      })
    
    });
    this.getBranches()
   this.breadcrumbItems = [
  { label: this.parentPage },
   ...(this.organizationName ? [{ label: this.organizationName }] : []),
  { label: 'Create Branch' }
];

  }

  onSubmit() {
    // Logo validation removed - logo is now optional
    // if (!this.branchData && !this.selectedFile) {
    //   this.logoError = true;
    // } else {
    //   this.logoError = false;
    // }
    if (this.branchForm.valid) {
      const formData = new FormData();
      const formControls = this.branchForm.controls;

      Object.keys(formControls).forEach((key) => {
        let value = formControls[key].value;

        if (value !== null && value !== undefined) {
          if (typeof value === 'boolean') {
            formData.append(key, value ? 'true' : 'false');
          } else {
            formData.append(key, value);
          }
        }
      });

      if (this.selectedFile) {
        formData.append('logo', this.selectedFile);
      }
      if (this.branchData) {
        // If editing, update the existing branch
        this.apiService.patch(`branch/update/${this.branchData.id}`, formData).subscribe({
          next: (res: any) => {
            this.toastr.success('Branch updated successfully!', 'Success');
            // this.closeModal();
            this.branchForm.patchValue(res);
            this.branchForm.get('organisation_id')?.disable();
            if (res && res?.data?.id) {
              this.store.dispatch(setBranchId({ branch_id: res?.data?.id }));
              this.branchData = res?.data;
              this.getBranches();
            }
          },
          error: (err) => {
            console.error('Error updating branch:', err);
            this.toastr.error(err.error?.message || 'Failed to update branch.', 'Error');
          }
        });
      } else {
        // If adding, create a new branch
        this.apiService.post('branch', formData).subscribe({
          next: (res: any) => {
            this.toastr.success('Branch created successfully!', 'Success');
            // this.closeModal();
            if (res && res?.data?.id) {
              this.store.dispatch(setBranchId({ branch_id: res?.data?.id }));
              this.store.dispatch(setOrganisationId({ organisation_id: res?.data?.organisation_id }));
              this.branchData = res?.data;
            }
             this.getBranches();
          },
          error: (err) => {
            console.error('Error creating branch:', err);
            this.toastr.error(err.error?.message || 'Failed to create branch.', 'Error');
          }
        });
      }
    } else {
      this.branchForm.markAllAsTouched();
    }
  }

  onFileSelected(event: any) {
    this.selectedFile = event.target.files[0] || null;
  }

  decimalPrecisionValidator(precision: number, scale: number): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value) return null;
      const regex = new RegExp(`^-?\\d{1,${precision - scale}}(\\.\\d{1,${scale}})?$`);
      return regex.test(control.value) ? null : { decimalPrecision: true };
    };
  }

  getOrganisation(): void {
    this.apiService.get('organisation').subscribe({
      next: (res: any) => {
        this.organizationsList = res.data;
        this.cdr.detectChanges();
        if (this.branchData) {
          this.branchForm.patchValue(this.branchData);
          if(this.currentFlow) this.branchForm.get('organisation_id')?.disable();
          this.logoPreview = (this.branchData?.logo);

        }
      },
      error: (err) => {
        console.log(err);
      }
    })
  }
 

  onGridReady(params: GridReadyEvent) {
    this.gridApi = params.api;
    this.gridApi.setGridOption('context', { componentParent: this });
  }

  getHtml(params: any) {
    const view = this.cellTemplate.createEmbeddedView({
      rowData: params.data,
    });
    view.detectChanges();
    const div = document.createElement('div');
    if (view.rootNodes.length > 0) {
      div.appendChild(view.rootNodes[0]);
      return div;
    } else {
      console.error('view.rootNodes is empty');
      return '';
    }
  }

  getBranches(): void {
    if(!this.organisationId) return;
    this.apiService.get(`branch/organization/${this.organisationId}`).subscribe({
      next: (res: any) => {
        this.rowData = res.data;
      },
      error: (err) => {
        console.log(err);
      }
    })
  }
 getLocality(){
  this.apiService.get('localities').subscribe({
    next: (res: any) =>{
      this.localityList = res.data;
      this.branchForm.patchValue({ locality_id: this.branchData?.locality_id });
      console.log('localityList', this.localityList )
    },
    error: (err) => {
      console.log(err);
    }
  })
 }
  editRow(rowData: any) {
    this.branchData = rowData;
    this.branchForm.patchValue(this.branchData);
    if(this.currentFlow) this.branchForm.get('organisation_id')?.disable();
    this.store.dispatch(setBranchId({ branch_id: rowData?.id }));
    this.store.dispatch(setOrganisationId({ organisation_id: rowData?.organisation_id }));
  }

  deleteRow(rowData: any) {
    this.selectedRowData = rowData;
    this.confirmDialog.openModal(rowData);
  }

  onConfirmDelete() {
    if (!this.selectedRowData) return;

    this.apiService.delete(`branch/${this.confirmDialog.rowData.id}`).subscribe({
      next: () => {
        this.toastr.success('Branch deleted successfully!', 'Success');
        this.getBranches();
      },
      error: (err: any) => {
        console.error('Error deleting branch:', err);
        this.toastr.error(err.error?.message || 'Failed to delete branch.', 'Error');
      }
    });
  }

  loadOrganizations() {
  this.apiService.get('organisation').subscribe({
    next: (res: any) => {
      this.organizationsList = res.data;
    },
    error: (err) => console.log(err)
  });
}

  ngAfterViewInit() {
    setTimeout(() => {
      this.setupBackdropClickListener();
    }, 500);
  }

  setupBackdropClickListener() {
    const modalElement = document.querySelector('.modal.show') as HTMLElement;
    const modalDialog = modalElement?.querySelector('.modal-dialog') as HTMLElement;

    if (!modalElement || !modalDialog) return;

    // Add event listener for backdrop click
    modalElement.addEventListener('click', (event: MouseEvent) => {
      const target = event.target as HTMLElement;

      // Check if the click is on the backdrop (not inside the modal dialog)
      if (target === modalElement) {
        this.triggerCloseAnimation(modalElement, modalDialog);
      }
    });
  }

  triggerCloseAnimation(modalElement: HTMLElement, modalDialog: HTMLElement) {
    const style = document.createElement('style');
    style.innerHTML = `
      @keyframes slideOutRight {
        from {
          transform: translateX(0);
        }
        to {
          transform: translateX(100%);
        }
      }
    `;
    document.head.appendChild(style);
    modalDialog.style.animation = 'slideOutRight 0.3s ease-out';

    setTimeout(() => {
      modalElement.style.visibility = 'hidden';
      modalElement.style.pointerEvents = 'none';
      this.modalClosed.emit();
      this.branchModalRef.hide();
      this.cdr.detectChanges();
      modalDialog.style.animation = '';
    }, 250);
  }
  
  closeModal() {
    const modalElements = document.querySelectorAll('.modal.show');
    const modalElement = modalElements[modalElements.length - 1] as HTMLElement;
    const modalDialog = modalElement?.querySelector('.modal-dialog') as HTMLElement;

    if (!modalElement || !modalDialog) return;

    this.triggerCloseAnimation(modalElement, modalDialog);
    this.modalClosed.emit();
    this.branchModalRef.hide();
    this.cdr.detectChanges();
  }

  isDeletedChange(e: any): void {
    this.branchForm.get('deleted')?.setValue(!e?.checked)
  }

  arrayBufferToBase64(buffer: any): string {
    let binary = '';
    const bytes = new Uint8Array(buffer);
    for (let i = 0; i < bytes.byteLength; i++) {
      binary += String.fromCharCode(bytes[i]);
    }
    return 'data:image/png;base64,' + btoa(binary);
  }

  openUserModal() {
    this.modalRef = this.modalService.show(CreateUserComponent, {
      class: 'modal-lg my-custom-class',
      backdrop: true,
      ignoreBackdropClick: true,
      keyboard: false,
      animated: true,
      initialState: {
        parentPage: 'Branch',
      }
    });
  }

  createAnotherBranch(): void {
    this.branchForm.reset();
    this.branchData = null;
  }

  ngOnDestroy() {
    this.store.dispatch(clearBranchId());
    this.store.dispatch(clearOrganisationId());
  }
}
